import { render, staticRenderFns } from "./BookletPartEdit.vue?vue&type=template&id=19107401&scoped=true"
import script from "./BookletPartEdit.vue?vue&type=script&lang=js"
export * from "./BookletPartEdit.vue?vue&type=script&lang=js"
import style0 from "./BookletPartEdit.vue?vue&type=style&index=0&id=19107401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19107401",
  null
  
)

export default component.exports